import { render, staticRenderFns } from "./UserOrders.vue?vue&type=template&id=0c63334e&"
import script from "./UserOrders.vue?vue&type=script&lang=js&"
export * from "./UserOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports